module.exports = __webpack_public_path__ + "img/stc-pay.af0d67ec.png";